import { useForm, useFormContext, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { TIssueTypeFormSchema, IssueTypeFormSchema } from '../schema'

/**
 * Props that we shouldn't overwrite
 */
type TOmittedProps = 'mode' | 'resolver'

interface IUseUserFormProps extends Omit<UseFormOptions<TIssueTypeFormSchema>, TOmittedProps> {}

const getDefaultValues = (defaultValues = {}) => ({
  ...IssueTypeFormSchema.cast(defaultValues),
})

/**
 * Issue Type form for creating or editing Issue Types
 * In the Issue Management Control Panel
 */
const useIssueTypeForm = (props: IUseUserFormProps = {}) => {
  const { defaultValues = {} } = props || {}

  return useForm<TIssueTypeFormSchema>({
    resolver: yupResolver(IssueTypeFormSchema),
    mode: 'onChange',
    defaultValues: {
      ...getDefaultValues(defaultValues),
    },
    ...props,
  })
}

export const useIssueTypeFormContext = () => useFormContext<TIssueTypeFormSchema>()

export default useIssueTypeForm
